import axios from 'axios';

export const apiService = axios.create({
  baseURL: 'https://techsolutionsservice.ustdev.com/',
    headers: {
      'Content-Type': 'application/json',
    }
  });

  export const API_BASE_URL = 'https://techsolutionsservice.ustdev.com/';
export const apiRequest = async (method, endpoint, data = null) => {
  try {
      const config = {
          method: method,
          url: `${API_BASE_URL}${endpoint}`,
          data: data,
          headers:{
            Authorization:`Bearer ${sessionStorage.getItem("authToken")}`
          }
          
          
      };
      const response = await axios(config,{headers:{
        Authorization:`Bearer ${sessionStorage.getItem("authToken")}`
      }});
      return response.data;
  } catch (error) {
      console.error(`Error with ${method} request to ${endpoint}`, error);
      throw error;
  }
};
